import React from 'react';
import { Card, StatStyles, Text } from '@highereducation/hen-ui';
import { parseHtmlString } from '@de/shared/utils';
import type { GraphicCardConfig } from '@de/types/types';

const GraphicCard: React.FC<GraphicCardConfig> = ({
  text = 'Online programs can cut the time it takes to get your degree by 50%.',
  graphic = 'horizontal',
  itemNameOne = 'Online',
  itemNameTwo = 'Traditional',
  sourceText = 'Source',
}) => {
  //TODO add fields in admin to control this
  const bars = [
    { label: itemNameOne, value: 60, variant: 'tertiary' as const },
    { label: itemNameTwo, value: 100, variant: 'primary' as const },
  ];

  const isHorizontal = graphic === 'horizontal';

  return (
    <Card className='w-full' variant='background-white'>
      <Card.Content>
        <Text variant='b4' color='subtext'>
          {parseHtmlString(text)}
        </Text>
        <StatStyles
          style={isHorizontal ? 'bars-horizontal' : 'bars-vertical'}
          bars={bars}
          className={isHorizontal ? undefined : 'h-36'}
        />
        {sourceText && (
          <Text variant='b5' color='subtext' className='font-bold underline'>
            {parseHtmlString(sourceText)}
          </Text>
        )}
      </Card.Content>
    </Card>
  );
};

export default GraphicCard;
